import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'
import compose from 'recompose/compose'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import LinearProgress from '@material-ui/core/LinearProgress'
import { saveAs } from 'file-saver'

import green from '@material-ui/core/colors/green'

import ButtonIcon from '@material-ui/icons/Description'

const styles = theme => ({
    snackbarContent : {
        '& > div' : {
            width : '100%'
        }
        // message : {
        //     width : '100%'
        // }
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
})

const EXCEL_REPORT_BASE_URL = `${process.env.API_URL}/api/v1/reportes_excel`

class DownloadExcelReport extends Component {

    state = {
        snackbarOpen : false,
        loading : false,
        message : 'Cargando...',
        task_id : null,
        filename : '',
        progress : 0,
        error : false,
    }
    statusInterval = null

    check_report_status = () => {
        const { task_id } = this.state
        fetch(`${EXCEL_REPORT_BASE_URL}/async_status/${task_id}/`)
            .then(response => ( response.json() ))
            .then(res => {
                if(res.status === "PENDING"){
                    if(res.data.status === "GETTING_DATA"){
                        let message = "Consultando registros (esto podría tardar unos minutos)"
                        this.setState({ message })
                    }
                    else if(res.data.status === "PROCESSING_ROWS"){
                        let progress = (res.data.current / res.data.total) * 100
                        let message = `Procesando registros (${res.data.current}/${res.data.total})`
                        this.setState({ message, progress })
                    }
                }
                else if(res.status === "SUCCESS"){
                    clearInterval(this.statusInterval)
                    this.setState({ message : "Descargando reporte...", filename : res.data.file_name })
                    this.download_generated_report()
                }else{
                    throw Error('Error')
                }
            })
            .catch(error => {
                console.error(error)
                clearInterval(this.statusInterval)
                this.setState({ loading : false, error : true, message : 'Error al generar reporte' })
            })

    }

    download_generated_report = () => {
        const { task_id, filename } = this.state
        fetch(`${EXCEL_REPORT_BASE_URL}/async_generated/${task_id}/`, {
            headers: {
              'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
        })
        .then(response => {
            return response.blob()
        })
        .then(blob => {
            this.setState({ message : "Descarga completada", loading : false, snackbarOpen : false })
            saveAs(blob, filename)
        })
        .catch(error => {
            console.error(error)
            this.setState({ loading : false, error : true, message : 'Error al descargar reporte' })
        })
    }

    handleClick = () => {
        const { resource } = this.props
        console.log(resource)
        this.setState({ snackbarOpen : true, loading : true })
        fetch(`${EXCEL_REPORT_BASE_URL}/${resource}/async/`)
            .then(response => {
                return response.json()
            })
            .then(data => {
                this.setState({ task_id : data.task_id })
                this.statusInterval = setInterval(() => {
                    this.check_report_status()
                }, 1000)
            })
            .catch(error => {
                console.error(error)
                clearInterval(this.statusInterval)
                this.setState({ loading : false, error : true })
            })


    }

    componentWillUnmount(){
        if(this.statusInterval){
          clearInterval(this.statusInterval)
        }
    }

    render() {
        const { classes } = this.props
        const { snackbarOpen, loading, message, progress } = this.state
        return (
            <Fragment>
                <Button label={!loading ? "Reporte Excel" : "Generando Reporte"} onClick={this.handleClick} disabled={loading}>
                    {!loading 
                    ? <ButtonIcon/>
                    : <CircularProgress size={20} />
                    }
                </Button>
                <Snackbar
                    anchorOrigin={{ vertical : 'bottom', horizontal : 'right' }}
                    open={snackbarOpen}
                    // onClose={this.handleClose}
                >
                    <SnackbarContent
                        className={classes.snackbarContent}
                        message={
                            <div>
                                <span id="message-id">{message}</span>
                                <LinearProgress variant="determinate" value={progress} />
                            </div>
                        }
                    />   
                </Snackbar>
            </Fragment>
        )
    }
}

// export default connect(undefined, { startUndoable })(DownloadExcelReport)

const enhance = compose(
    connect( null, {}),
    withStyles(styles)
)
export default enhance(DownloadExcelReport)
